import React, { Fragment } from 'react';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from "../dayjs-config";
import { DayjsFormatTypes } from "../utils";
import { getDayjsDate } from "./util";
import { useFormattedDate } from "../hooks/useFormattedDate";
dayjs.extend(localizedFormat);

var FormattedDate = function FormattedDate(_ref) {
  var _ref$format = _ref.format,
      format = _ref$format === void 0 ? DayjsFormatTypes.Date : _ref$format,
      date = _ref.date,
      variant = _ref.variant;
  var Tag = variant || Fragment;
  var dayjsDate = getDayjsDate(date, format);
  var dateString = useFormattedDate(date, format);
  return dayjsDate.isValid() ? React.createElement(Tag, null, dateString) : React.createElement(React.Fragment, null, "Invalid date");
};

export default FormattedDate;